/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AlbumManagementListAlbumResponse } from "./AlbumManagementListAlbumResponse";

export type AlbumManagementListAlbumResponseApiRespoonse = {
  data?: AlbumManagementListAlbumResponse;
  status?: AlbumManagementListAlbumResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AlbumManagementListAlbumResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
